export const isRunningInElectron = typeof window.electron !== 'undefined'
